import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CURRENCIES, Currency } from '../../enums/price/currencies.enum';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { TranslateModule } from '@ngx-translate/core';
import { NumberInputDirective } from '../../directives/number-input.directive';
import { AutoFocusModule } from 'primeng/autofocus';

export interface IHourRateFG {
  value: FormControl<number | null>;
  currency: FormControl<Currency>;
};

export const getHourRateFG = (initCurrency: Currency = Currency.CZK) => {
  return new FormGroup<IHourRateFG>({
    currency: new FormControl(initCurrency, { nonNullable: true, validators: [ Validators.required ] }),
    value: new FormControl(null)
  });
};

@Component({
  selector: 'app-hour-rate-fg',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,
    DropdownModule, InputNumberModule, TranslateModule, NumberInputDirective, AutoFocusModule
  ],
  templateUrl: './hour-rate-fg.component.html',
  styleUrls: ['./hour-rate-fg.component.scss']
})
export class HourRateFgComponent implements OnInit {
  CURRENCIES = CURRENCIES;

  @Input({required: true}) fg: FormGroup<IHourRateFG> | undefined;
  @Input() appendTo: any = 'body';
  @Input() placeholder: string | null = 'shared.hour-rate.value.placeholder';
  @Input() autofocus: boolean = false;


  constructor() { }

  ngOnInit(): void {
  }

}
